import React, { useContext } from 'react';
import { Typography, Grid, Paper, Box, Divider } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import PersonIcon from '@material-ui/icons/Person';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { AuthContext } from "../../../context/Auth/AuthContext";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(3),
    background: '#f8f9fa',
    border: '1px solid #e9ecef',
    height: '100%',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#2d3748',
    marginBottom: theme.spacing(2),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: theme.spacing(1.2, 0),
    borderBottom: '1px solid #e9ecef',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  icon: {
    color: '#667eea',
    fontSize: '1.3rem',
  },
  label: {
    color: '#8898aa',
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  value: {
    color: '#2d3748',
    fontWeight: 600,
    fontSize: '0.95rem',
    marginLeft: 'auto',
    textAlign: 'right',
    wordBreak: 'break-word',
  },
  totalValue: {
    color: '#667eea',
    fontWeight: 800,
    fontSize: '1.1rem',
    marginLeft: 'auto',
  },
}));

function PaymentDetails(props) {
  const { formValues } = props;
  const classes = useStyles();
  const { firstName, zipcode, plan } = formValues;
  const { user } = useContext(AuthContext);
  const newPlan = JSON.parse(plan);
  const { price } = newPlan;

  return (
    <Grid item xs={12} sm={6}>
      <Paper elevation={0} className={classes.paper}>
        <Typography className={classes.title}>
          Informação de pagamento
        </Typography>
        <Box className={classes.row}>
          <EmailIcon className={classes.icon} />
          <Typography className={classes.label}>Email</Typography>
          <Typography className={classes.value}>{user.email}</Typography>
        </Box>
        <Box className={classes.row}>
          <PersonIcon className={classes.icon} />
          <Typography className={classes.label}>Nome</Typography>
          <Typography className={classes.value}>{firstName || '-'}</Typography>
        </Box>
        <Box className={classes.row}>
          <CreditCardIcon className={classes.icon} />
          <Typography className={classes.label}>CPF/CNPJ</Typography>
          <Typography className={classes.value}>{zipcode || '-'}</Typography>
        </Box>
        <Divider style={{ margin: '12px 0', backgroundColor: '#e9ecef' }} />
        <Box className={classes.row}>
          <AttachMoneyIcon className={classes.icon} />
          <Typography className={classes.label} style={{ fontWeight: 700, color: '#2d3748' }}>Total</Typography>
          <Typography className={classes.totalValue}>
            R${Number(price).toLocaleString('pt-br', { minimumFractionDigits: 2 })}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );
}

export default PaymentDetails;
